import '../styles/Intro.css';

const introContent = {
  swe: {
    eyebrow: 'Vilka vi är',
    title: 'Om Execora Consulting AB',
    text: 'Execora Consulting ingår i Profital Group tillsammans med Profital Ekonomi AB, en auktoriserad redovisningsbyrå. Den kombinationen gör oss unika.',
    highlight: 'Vi förenar djup ekonomisk expertis med bred specialistkompetens inom rekrytering och bemanning.',
    description: 'Genom vårt nätverk har vi nära kontakt med både nyexaminerade och seniora ekonomer, mjukvaruutvecklare, hårdvaruutvecklare, ingenjörer, affärsutvecklare och andra specialister. Det innebär fler möjligheter, fler karriärvägar och en starkare helhet för dig som specialist och för företag som söker rätt kompetens.',
    cta: 'Läs mer om oss'
  },
  eng: {
    eyebrow: 'Who we are',
    title: 'About Execora Consulting AB',
    text: 'Execora Consulting is part of Profital Group together with Profital Ekonomi AB, an authorized accounting firm. This combination makes us unique.',
    highlight: 'We combine deep financial expertise with broad consulting competence.',
    description: 'Through our network, we maintain close contact with both newly graduated and senior professionals in finance, software development, hardware development, engineering, business development, and other specialist areas. This creates more opportunities, more career paths, and a stronger overall solution for both specialists and companies seeking the right competence.',
    cta: 'Learn more about us'
  }
};

function Intro({ lang = 'swe', onNavigate = () => {} }) {
  const text = introContent[lang] || introContent.swe;

  const goToAbout = () => {
    onNavigate('about');
  };

  return (
    <section className="intro-section">
      <div className="intro-container">
        <div className="intro-content">
          <p className="intro-eyebrow">{text.eyebrow}</p>
          <h2 className="intro-title">{text.title}</h2>
          <p className="intro-text">{text.text}</p>
          <p className="intro-highlight">{text.highlight}</p>
          <p className="intro-description">{text.description}</p>
          <button type="button" className="intro-button" onClick={goToAbout}>
            {text.cta}
          </button>
        </div>
        <div className="intro-visual">
          <div className="intro-stats">
            <div className="stat-item"><div className="stat-number">150+</div><div className="stat-label">specialister</div></div>
            <div className="stat-item"><div className="stat-number">10+</div><div className="stat-label">kunder</div></div>
            <div className="stat-item"><div className="stat-number">20+</div><div className="stat-label">uppdrag</div></div>
            <div className="stat-item"><div className="stat-number">10+</div><div className="stat-label">års erfarenhet</div></div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Intro;
 